"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Box = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const slot_js_1 = require("./slot.js");
const box_props_js_1 = require("./box.props.js");
const index_js_1 = require("../helpers/index.js");
const Box = React.forwardRef((props, forwardedRef) => {
    const { className, asChild, as: Tag = 'div', ...boxProps } = (0, index_js_1.extractProps)(props, box_props_js_1.boxPropDefs, index_js_1.layoutPropDefs, index_js_1.deprecatedLayoutPropDefs, index_js_1.marginPropDefs);
    const Comp = asChild ? slot_js_1.Slot : Tag;
    return React.createElement(Comp, { ...boxProps, ref: forwardedRef, className: (0, classnames_1.default)('rt-Box', className) });
});
exports.Box = Box;
Box.displayName = 'Box';
//# sourceMappingURL=box.js.map